import Vue from 'vue';
import { SButton, SInput } from "../../../components/ui-components";
import LabelNew from '../../../components/base/vacancies/label-new'
import { formatTimeISO }  from "../../utils/utils"
export default Vue.component('vacancies', {
  components: {
    SButton,
    SInput,
    LabelNew
  },
  data() {
    return {
      formVacancies: {}
    }
  },
  created() {},
  methods: {
    formatTimeISO,
  }
});
